import { Button } from '@mantine/core';
import { primaryColor } from '../../../../constants/theme';
import { IconCalendar } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { ProfileResponseModel } from '../../../../types/Profile';

export const BookAppointmentsButton = ({
  profile,
  width,
}: {
  profile?: ProfileResponseModel;
  width?: string | number;
}) => {
  const navigate = useNavigate();

  if(!profile?.isProfessional) {
    return null;
  }

  const handleClick = () => {
    navigate('/book-appointment', {
      state: {
        professionalId: profile?.id,
        professionalName: profile?.fullName,
        professionalProfilePicture: profile?.profilePicture,
      },
    });
  };

  return (
    <Button
      variant="outline"
      color={primaryColor}
      leftSection={<IconCalendar size={20} />}
      onClick={handleClick}
      w={width}
    >
      Book Conversation
    </Button>
  );
};
